import { useState, useEffect } from 'react';
import axios from 'axios';
import { Crosshair, TrendUp, TrendDown, X } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

// Muestra rótulos persistentes de cruce de niveles marcados.
// La DETECCIÓN ocurre 24/7 en el servidor (services/level_watcher.py);
// aquí solo se consultan los avisos cada 60s y se muestran hasta que el usuario los cierre.
const LevelCrossWatcher = ({ onTickerSelect }) => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const load = () => {
      axios.get(`${API}/user/level-events`, { headers: getAuthHeaders() })
        .then(res => setEvents(res.data?.level_events || []))
        .catch(() => {});
    };
    load();
    const interval = setInterval(load, 60000);
    return () => clearInterval(interval);
  }, []);

  const dismissBanner = (eventId) => {
    setEvents(prev => prev.map(ev => ev.id === eventId ? { ...ev, dismissed: true } : ev));
    axios.post(`${API}/user/level-events/${eventId}/dismiss`, {}, { headers: getAuthHeaders() }).catch(() => {});
  };

  const visible = events.filter(ev => !ev.dismissed);
  if (visible.length === 0) return null;

  return (
    <div className="fixed top-16 left-1/2 -translate-x-1/2 z-[9999] flex flex-col gap-2.5 w-[360px]" data-testid="level-cross-banners">
      {visible.map(ev => {
        const up = ev.direction === 'up';
        const accent = up ? '#00ff6a' : '#ff4444';
        return (
          <div
            key={ev.id}
            data-testid={`level-cross-banner-${ev.ticker}`}
            className="rounded-xl px-4 py-3 shadow-2xl"
            style={{
              background: 'rgba(9,9,11,0.92)',
              border: '1px solid rgba(217,70,239,0.45)',
              backdropFilter: 'blur(16px)',
              boxShadow: `0 0 24px rgba(217,70,239,0.25), 0 8px 32px rgba(0,0,0,0.6)`,
              animation: 'priceTagFlash 0.8s ease-out'
            }}
          >
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0 mt-0.5" style={{ background: 'rgba(217,70,239,0.15)', border: '1px solid rgba(217,70,239,0.4)' }}>
                <Crosshair size={16} color="#e879f9" weight="bold" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => onTickerSelect?.(ev.ticker)}
                    className="font-bold text-sm text-white hover:text-zinc-300 transition-colors"
                    data-testid={`banner-goto-${ev.ticker}`}
                  >
                    {ev.ticker}
                  </button>
                  {up
                    ? <TrendUp size={15} color={accent} weight="bold" />
                    : <TrendDown size={15} color={accent} weight="bold" />}
                  <span className="text-[11px] font-mono px-1.5 py-0.5 rounded" style={{ color: accent, background: up ? 'rgba(0,255,106,0.1)' : 'rgba(255,68,68,0.1)' }}>
                    {up ? 'SUPERÓ' : 'PERDIÓ'} {Number(ev.level).toFixed(2)}€
                  </span>
                </div>
                <p className="text-xs text-zinc-400 mt-1 font-mono">
                  Precio en el cruce: <span className="text-white font-bold">{Number(ev.price).toFixed(2)}€</span>
                </p>
                {ev.note && (
                  <p className="text-[11px] text-zinc-500 italic mt-1 border-l-2 pl-2" style={{ borderColor: 'rgba(217,70,239,0.4)' }}>{ev.note}</p>
                )}
                <p className="text-[10px] text-zinc-600 mt-1">
                  {new Date(ev.triggered_at).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })} · guardado en Centro de Alertas
                </p>
              </div>
              <button
                data-testid={`dismiss-banner-${ev.ticker}`}
                onClick={() => dismissBanner(ev.id)}
                className="p-1 rounded-lg hover:bg-zinc-700/60 transition-colors shrink-0"
                title="Cerrar rótulo (el aviso queda en el Centro de Alertas → Órdenes condicionadas)"
              >
                <X size={14} color="#a1a1aa" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LevelCrossWatcher;
